module.exports = __webpack_public_path__ + "static/media/kecamatan digidesa.b19be511.png";